import { Box, Grid, Stack, Typography } from "@mui/material";
import React, { FC } from "react";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../hooks/useResponsive";
import { formatDecimalNumber } from "../utils/url-id";

export const InfoBox: FC<{ title: string; value: number; icon: any }> = ({
    title,
    value,
    icon,
  }) => {
    const theme = useTheme();
    return (
      <Box
        sx={{
          padding: "1.4rem",
          background: theme.palette.common.white,
          borderRadius: "7px",
        }}
      >
        <Stack direction={"row"} alignItems={"center"} sx={{ gap: "20px", mb: 2 }}>
          {icon}
          <Typography
            variant="subtitle2"
            sx={{
              fontFamily: "Inter",
              fontWeight: "700",
              color: theme.palette.neutral.light,
            }}
          >
            {title}
          </Typography>
        </Stack>
        <Stack direction={"row"} justifyContent={"flex-end"}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              fontFamily: "Inter",
              color: theme.palette.neutral.main,
            }}
          >
            {value}
          </Typography>
        </Stack>
      </Box>
    );
  };